module.exports = __webpack_public_path__ + "static/OldMansJourney0-593ef1af1691c7aa6810bfc9a6ddd278.png";